import { Table } from '@tanstack/react-table';
import { useCallback } from 'react';

import { IPairWallet } from 'api/apiPairs/models';
import { useTypedDispatch, useTypedSelector } from 'store';
import { setCopyPopupShow } from 'store/slices/ui';
import { IWalletTableRow } from 'types/tables/dex/walletTableRow';
import { Button } from 'ui/Button/Button';
import { TableCheckbox } from 'ui/Table/TableCheckbox/TableCheckbox';
import { copyToClipboard } from 'utils/clipboard';

interface IWalletAddressHeadProps {
  table: Table<IWalletTableRow>;
  selectedWallets: IPairWallet[];
  singleSelect: boolean;
}

const WalletAddressHead = ({ table, selectedWallets, singleSelect }: IWalletAddressHeadProps) => {
  const dispatch = useTypedDispatch();
  const isAdmin = useTypedSelector(store => store.auth.isAdmin);

  const handleCopy = useCallback(async () => {
    const rows = selectedWallets;

    if (!rows.length) return undefined;

    const innerText = rows.reduce(
      (acc, row, idx) => acc + row.address + (idx !== rows.length - 1 ? '\n' : ''),
      '',
    );

    try {
      await copyToClipboard(innerText);
      dispatch(setCopyPopupShow(true));
    } catch (error) {
      console.log('error: ', error);
    }
  }, [selectedWallets, dispatch]);

  return (
    <div className="checkbox-area">
      {isAdmin && !singleSelect && (
        <TableCheckbox
          id="select-all"
          checked={table.getIsAllRowsSelected()}
          indeterminate={table.getIsSomeRowsSelected()}
          onChange={table.getToggleAllRowsSelectedHandler()}
        />
      )}
      <span>Address</span>
      {selectedWallets.length > 0 && (
        <Button className="mm-copy-wallets-button" size="small" onClick={handleCopy}>
          Copy
        </Button>
      )}
    </div>
  );
};

export default WalletAddressHead;
